import options from './contact.component';

export default {
    selector: "dtEmulatorContact",
    options
}